const urls = {
  qa: 'wss://connect.okqa.work:443/ws/v3',
  dev: 'wss://connect.okdev.work:443/ws/v3',
  prod: 'wss://connect.okcoin.jp:443/ws/v3',
  stage: 'wss://stage-connect.okqa.work:443/ws/v3',
  uat: 'wss://uat-connect.okqa.work:443/ws/v3',
  rehe: 'wss://rehe-connect.okqa.work:443/ws/v3',
};

// 新系统ws地址
const urlsV2 = {
  qa: 'wss://connect.okqa.work:443/ws/v3',
  dev: 'wss://connect-new.okdev.work:443/ws/v3',
  prod: 'wss://connect.okcoin.jp:443/ws/v3',
  stage: 'wss://stage-connect-aircraft.okqa.work:443/ws/v3',
  uat: 'wss://uat-connect-aircraft.okqa.work:443/ws/v3',
  rehe: 'wss://rehe-connect-migration.okqa.work:443/ws/v3',
};

/**
 * @deprecated old logic
 * FIXME: 验证 getConnectUrlApollo 正确后可以删除这个函数
 * @returns {string | undefined}
 */
function getConnectUrlLegacy() {
  let url;
  {
    const host = window.location.hostname;
    const isQa = host.includes('okqa') || host.includes('localhost');
    const isDev = host.includes('okdev');
    const isStage = host.includes('stage');
    const isUat = host.includes('uat');
    const isRehe = host.includes('rehe');
    let env = 'prod';
    if (isQa) {
      env = 'qa';
      // stage env -- stage-www.okqa.work
      if (isStage) {
        env = 'stage';
      }
      // uat env -- uat-www.okqa.work
      if (isUat) {
        env = 'uat';
      }
      // rehe env -- rehe-www.okqa.work
      if (isRehe) {
        env = 'rehe';
      }
    } else if (isDev) {
      env = 'dev';
    }

    const { isUnifiedAccount = false } = window.okGlobal;

    const URLS = isUnifiedAccount ? urlsV2 : urls;
    let url = URLS[env];
    // new qa k8s ws connect url
    if ((isQa || isDev) && /^.+-exchange/.test(host)) {
      const prefix = host.substring(0, host.indexOf('-exchange'));
      url = url.replace('connect', `${prefix}-connect`);
    }

    // for debugging or testing
    if (localStorage.wsConnectUrl) {
      url = localStorage.wsConnectUrl;
    }
    if (window.location.href.includes('debug_push=true')) {
      url += `${url.indexOf('?') > -1 ? '&' : '?'}_compress=false`;
    }
    return url;
  }
};

/**
 * 从okGlobal中取Apollo的配置
 * @returns {string | undefined}
 */
function getConnectUrlApollo() {
  const { isUnifiedAccount = false } = window.okGlobal;
  return isUnifiedAccount
    ? window.okGlobal.wsConnectAircraftUrl
    : window.okGlobal.wsConnectLegacyUrl;
}

function getConnectUrl() {
  let url = getConnectUrlApollo(); /* ?? getConnectUrlLegacy(); */
  // for debugging or testing
  if (localStorage.wsConnectUrl) {
    url = localStorage.wsConnectUrl;
  }
  // for compress testing
  if (window.location.href.includes('debug_push=true')) {
    url += `${url.indexOf('?') > -1 ? '&' : '?'}_compress=false`;
  }
  return url;
}
export default { getConnectUrl };
